import { useEffect, useState } from 'react';
import {
  ensureIpcStatusEnumsLoaded,
  isIpcStatusEnumsLoaded,
  subscribeIpcStatusEnums,
  projectStatusLabel,
  milestoneStatusLabel,
  milestonePhaseLabel,
  specStatusLabel,
  projectStatusOptions,
  milestoneStatusOptions,
  milestonePhaseOptions,
  specStatusOptions,
  nodeCompletionMethodLabel,
  nodeCompletionMethodOptions,
} from './ipcStatusEnums';

/** 确保状态枚举已加载，加载后触发重渲染 */
export function useIpcStatusEnums() {
  const [ready, setReady] = useState(isIpcStatusEnumsLoaded());

  useEffect(() => {
    let cancelled = false;
    const unsub = subscribeIpcStatusEnums(() => {
      if (!cancelled) setReady(true);
    });
    void ensureIpcStatusEnumsLoaded().then(() => {
      if (!cancelled) setReady(isIpcStatusEnumsLoaded());
    });
    return () => {
      cancelled = true;
      unsub();
    };
  }, []);

  return {
    ready,
    projectStatusLabel,
    milestoneStatusLabel,
    milestonePhaseLabel,
    specStatusLabel,
    projectStatusOptions,
    milestoneStatusOptions,
    milestonePhaseOptions,
    specStatusOptions,
    nodeCompletionMethodLabel,
    nodeCompletionMethodOptions,
  };
}
